/* eslint-disable */
import React from 'react';
import cn from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {
  GenerateButton,
  ReportFilterPicker,
  ReportsDataPickerContainer,
  ReportsDatepicker,
  ReportsInfo,
  ReportTypePickerContainer,
  ViewByContainer,
  ViewByToggle
} from 'routes/App/reports/ReportsDataPicker/styles';
import ReportsDatepickerModule from 'routes/App/reports/ReportsPageDatepickerModule';
import IconGenerateReportButton from 'assets/iconGenerateReportButton';
import ReportsTypePicker from 'routes/App/reports/ReportsDataPicker/ReportsTypePicker';
import SelfDeliveryInvoicesPeriodPicker from 'routes/App/reports/ReportsDataPicker/SelfDeliveryInvoicesPeriodPicker';
import {
  SET_DATEPICKER_INDEX,
  SET_REPORTS_DATE_INTERVAL,
  SET_REPORT_TYPE,
  CLEAR_REPORT_DATA,
  SET_SELF_DELIVERY_DATE_FILTER,
  SET_TIME_PERIOD,
  SET_SELF_DELIVERY_INVOICES_PERIOD,
  SET_SALES_BREAKDOWN_CHANNELS,
  SET_SALES_BREAKDOWN_FULFILLMENTS
} from 'store/reports/action';
import {
  REPORT_TYPES,
  SALES_BREAKDOWN_CHANNEL_OPTIONS,
  SALES_BREAKDOWN_FULFILLMENT_OPTIONS,
  SELF_DELIVERY_DATE_FILTER_OPTIONS
} from 'helpers/constants/reports';
import CheckboxMultiSelect from 'components/select/CheckboxMultiSelect';
import CheckboxS2E from 'components/Checkbox';
import {DashboardField} from 'routes/App/dashboard/styles';

const ReportsDataPicker = ({
  generateButtonHandler,
  setIncludeModifiers,
  includeModifiers
}) => {
  const {
    dateRange,
    reportType,
    generationLoading,
    stripeIntersected,
    datePickerTabIndex,
    selfDeliveryDateFilter,
    selfDeliveryInvoicesPeriod,
    salesBreakdownChannels,
    salesBreakdownFulfillments
  } = useSelector((state) => state.reportsReducer);
  const dispatch = useDispatch();
  const Timezone = useSelector((state) => state.user.activeLocation.Timezone);
  const {email} = useSelector((state) => state.user.userData);

  const updateDate = (dateArray) => {
    const formattedDateArray = [
      dateArray[0]
        ? moment(dateArray[0])
            .utcOffset(Timezone, false)
            .utc()
            .format('YYYY-MM-DD')
        : null,
      dateArray[1]
        ? moment(dateArray[1])
            .utcOffset(Timezone, false)
            .utc()
            .format('YYYY-MM-DD')
        : null
    ];

    dispatch(SET_REPORTS_DATE_INTERVAL(formattedDateArray));
  };
  const setReportType = (type) => {
    if (type === reportType) return;
    dispatch(SET_REPORT_TYPE(type));
    dispatch(CLEAR_REPORT_DATA());
  };

  // Keep the stored index in sync so the picker restores the selection after a remount
  const updateSelectedDateIndex = (index) => {
    dispatch(SET_TIME_PERIOD(index));
    dispatch(SET_DATEPICKER_INDEX(index));
  };

  const setSelfDeliveryDateFilter = (value) => {
    dispatch(SET_SELF_DELIVERY_DATE_FILTER(value));
  };

  // Reports with extra filters in the row wrap the date picker onto its own line
  const hasExtraFilters =
    reportType === REPORT_TYPES.SALES_BREAKDOWN_SUMMARY ||
    reportType === REPORT_TYPES.SELF_DELIVERY_SUMMARY;

  return (
    <ReportsDataPickerContainer>
      <div
        className={cn('dataPickersContainer', {
          extraFiltersPickers: hasExtraFilters
        })}
      >
        <ReportTypePickerContainer>
          <span>Report type</span>
          <ReportsTypePicker
            reportType={reportType}
            setReportType={setReportType}
          />
        </ReportTypePickerContainer>
        {reportType === REPORT_TYPES.SELF_DELIVERY_SUMMARY && (
          <ViewByContainer>
            <span>View by</span>
            <ViewByToggle role='group' aria-label='View by'>
              {SELF_DELIVERY_DATE_FILTER_OPTIONS.map((option) => (
                <button
                  key={option.value}
                  type='button'
                  aria-pressed={selfDeliveryDateFilter === option.value}
                  data-gtm={`selfDeliveryViewBy${option.value}`}
                  onClick={() => setSelfDeliveryDateFilter(option.value)}
                >
                  {option.label}
                </button>
              ))}
            </ViewByToggle>
          </ViewByContainer>
        )}
        {reportType === REPORT_TYPES.SALES_BREAKDOWN_SUMMARY && (
          <>
            <ReportFilterPicker>
              <CheckboxMultiSelect
                labelId='sales-breakdown-channel-select-label'
                allLabel='All Channels'
                ariaLabel='Sales breakdown channels'
                options={SALES_BREAKDOWN_CHANNEL_OPTIONS}
                selected={salesBreakdownChannels || []}
                onChange={(channels) =>
                  dispatch(SET_SALES_BREAKDOWN_CHANNELS(channels))
                }
              />
            </ReportFilterPicker>
            <ReportFilterPicker>
              <CheckboxMultiSelect
                labelId='sales-breakdown-fulfillment-select-label'
                allLabel='All Fulfillments'
                ariaLabel='Sales breakdown fulfillments'
                options={SALES_BREAKDOWN_FULFILLMENT_OPTIONS}
                selected={salesBreakdownFulfillments || []}
                onChange={(fulfillments) =>
                  dispatch(SET_SALES_BREAKDOWN_FULFILLMENTS(fulfillments))
                }
              />
            </ReportFilterPicker>
          </>
        )}
        <ReportsDatepicker
          className={cn({extraFiltersDatepicker: hasExtraFilters})}
        >
          {reportType === REPORT_TYPES.SELF_DELIVERY_INVOICES ? (
            <SelfDeliveryInvoicesPeriodPicker
              value={selfDeliveryInvoicesPeriod}
              onChange={(value) =>
                dispatch(SET_SELF_DELIVERY_INVOICES_PERIOD(value))
              }
            />
          ) : (
            <ReportsDatepickerModule
              className='reportsDatepicker'
              date={dateRange}
              updateDate={updateDate}
              defaultSelectIndex={datePickerTabIndex}
              reportType={reportType}
              Timezone={Timezone}
              updateSelectedDateIndex={updateSelectedDateIndex}
            />
          )}
          <GenerateButton
            className={cn({
              animate: generationLoading
            })}
            onClick={generateButtonHandler}
          >
            <IconGenerateReportButton />
            <span>Generate</span>
          </GenerateButton>
        </ReportsDatepicker>
      </div>
      {reportType === REPORT_TYPES.SPECIAL_ORDERS ? (
        <div className='infoReportsContainerColumn'>
          <DashboardField className='w100 paddingL0'>
            <CheckboxS2E
              onChange={(e) => {
                setIncludeModifiers(e.target.checked);
              }}
              name='IncludeModifiers'
              checked={includeModifiers}
              label='Include Modifiers'
            />
          </DashboardField>
          <div className='infoReportsContainer'>
            <ReportsInfo>This report covers all your locations</ReportsInfo>
          </div>
          <div className='infoReportsContainer'>
            <ReportsInfo>
              Editing of this report will be available by email at {email}
            </ReportsInfo>
          </div>
        </div>
      ) : (
        <div className='infoReportsContainer'>
          <ReportsInfo>
            {reportType === REPORT_TYPES.SELF_DELIVERY_INVOICES
              ? 'Each row is one invoice charge date. Use Order Breakdown to download its orders'
              : stripeIntersected === 'merchant-wise'
              ? 'This report covers all of your locations'
              : stripeIntersected === 'several'
              ? 'This report covers some of your locations'
              : 'Export report to view full data'}
          </ReportsInfo>
        </div>
      )}
    </ReportsDataPickerContainer>
  );
};

ReportsDataPicker.propTypes = {
  generateButtonHandler: PropTypes.func.isRequired,
  setIncludeModifiers: PropTypes.func.isRequired,
  includeModifiers: PropTypes.bool.isRequired
};
export default ReportsDataPicker;
